<!--    <sb-progressbar [width]=verifiedPercentage mode="progressBar" classes="green-bg"></sb-progressbar>-->
<sb-chart chartType="pieChart" [chartData]="smallPie"></sb-chart>
